export default __webpack_public_path__ + "static/media/dse4520.126fd6e7.webp";